// extracted by mini-css-extract-plugin
module.exports = {"prog":"auth_prog__o0h7X"};